module.exports = __webpack_public_path__ + "static/media/startingPoint.dcb1af4c.svg";